<template>
  <div class="platform-sub-view wow fadeIn" data-wow-duration="1s" @mouseleave="onLeave">
    <div class="platform-sub-view-left wow fadeInLeft" data-wow-duration="1s">
      <p class="platform-sub-view-left-title" @click="onPlatformServiceClick">技术服务内容</p>
      <div class="platform-sub-view-left-content-item">
        <ul>
          <li v-for="(item, index) in data" :key="index" @click="onItemClick(item?.name)"
              class="list-item" data-wow-duration="1s">
            <span class="label">{{ item?.verbose_name ?? '' }}</span>
            <img src="../../assets/images/ic_right_double_arrow.png" alt="">
          </li>
        </ul>
      </div>
    </div>
    <div class="platform-sub-view-right wow fadeInRight" data-wow-duration="1s">
      <img class="platform-sub-view-right-img" src="../../assets/images/platform/ic_platform_top_img.webp" alt="">
      <div class="platform-sub-view-right-content" @click="onPlatformIntroClick">
        <span class="text-1">技术服务平台介绍</span>
        <span class="text-2">技术服务平台简介，硬件设施，仪器设备，人员配置等</span>
      </div>
    </div>
  </div>
</template>

<script setup>

// 传入的动态数据
import {getRequestPlatformListData} from "@/services/api.js"
import router from "@/router/router.js"
import store from "@/store/index.js";
// 使用 defineEmits 定义支持的事件
const emit = defineEmits(['send-platform-data'])

let data = ref([])

const getPlatformListData = async () => {
  try {
    const cachedData = localStorage.getItem('platformListData')
    if (cachedData) {
      data = JSON.parse(cachedData);
    } else {
      data = await getRequestPlatformListData()
      localStorage.setItem('platformListData', JSON.stringify(data))
    }
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

const onPlatformServiceClick = () => {
  store.commit('setPlatformTab', 0)
  router.push({name: 'platformService'})
  emit('send-platform-data', false) // 触发事件并传递参数
}

const onPlatformIntroClick = () => {
  store.commit('setPlatformTab', 0)
  router.push({name: 'platformIntro', params: {platform: 'InvivoPharmacology'}})
  emit('send-platform-data', false) // 触发事件并传递参数
}

const onItemClick = (name) => {
  store.commit('setPlatformTab', 0)
  router.push({name: 'platformServiceList', params: {name}})
  emit('send-platform-data', false) // 触发事件并传递参数
}

const onLeave = () => {
  emit('send-platform-data', false) // 触发事件并传递参数
}

onMounted(() => {
  getPlatformListData()
})

</script>

<style scoped lang="less">
.platform-sub-view {
  display: flex;
  width: 100%;
  height: 400px;
  align-items: center;
  background-color: #f8f8f8;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);

  .platform-sub-view-left:first-child {
    height: 70%; /* 设置竖线高度 */
    border-right: 1px solid #CACACA; /* 添加竖线 */
  }

  .platform-sub-view-left {
    flex: 1;

    .platform-sub-view-left-title {
      display: inline-block;
      margin-left: 428px;
      font-size: 16px;
      color: var(--main-color);
      margin-bottom: 40px;
      font-weight: bold;
      letter-spacing: 2px;
      cursor: pointer;
      box-shadow: 0 1px 0 0 var(--main-color); /* 模拟底部的线条 */
      transition: all 0.3s ease; /* 添加过渡效果 */
      padding-bottom: 2px; /* 给文字与线条之间留出一点空间 */
    }

    .platform-sub-view-left-title:hover {
      color: var(--main-sub-color);
      box-shadow: 0 2px 0 0 var(--main-sub-color); /* 鼠标移入时线条变色 */
    }

    .platform-sub-view-left-content-item {
      margin-left: 428px;

      ul {
        padding: 0;
        margin: 0;
      }

      .list-item {
        display: flex;
        align-items: center;
        margin-bottom: 23px;
        cursor: pointer;

        span:hover {
          color: var(--main-sub-color); /* 悬停时的背景色 */
        }

        .label {
          color: var(--font-color);
          font-size: 14px;
          letter-spacing: 2px;
          transition: all 0.3s ease; /* 添加过渡效果 */
        }

        img {
          margin-left: 5px;
          width: 10px;
          height: 10px;
        }
      }
    }
  }

  .platform-sub-view-right {
    flex: 1;

    .platform-sub-view-right-img {
      width: 290px;
      height: 153px;
      object-fit: cover;
      border-radius: 8px;
      margin-left: 150px;
    }

    .platform-sub-view-right-content {
      display: flex;
      flex-direction: column;
      cursor: pointer;

      span:nth-child(1) {
        display: inline-block; /* 使 span 成为块级元素，以便设置宽度和边框 */
        width: 148px;
        font-size: 16px;
        margin-top: 42px;
        margin-bottom: 32px;
        margin-left: 150px;
        color: var(--main-color);
        font-weight: bold;
        letter-spacing: 2px;
        box-shadow: 0 1px 0 0 var(--main-color); /* 模拟底部的线条 */
        transition: all 0.3s ease; /* 添加过渡效果 */
        padding-bottom: 2px; /* 给文字与线条之间留出一点空间 */

      }

      span:nth-child(2) {
        margin-left: 150px;
        color: var(--font-color);
        font-size: 14px;
        letter-spacing: 2px;
        transition: all 0.3s ease; /* 添加过渡效果 */
      }
    }

    .platform-sub-view-right-content:hover .text-1 {
      color: var(--main-sub-color);
      box-shadow: 0 2px 0 0 var(--main-sub-color); /* 鼠标移入时线条变色 */
    }

    .platform-sub-view-right-content:hover .text-2 {
      color: var(--main-sub-color);
    }
  }
}

</style>